export const drawClientLabel = (client) => {
    return `${client.firstName} ${client.lastName ?? ""} - ${client.phone}`;
};
export const drawTariffLabel = (tariff) => {
    return `${tariff.name} - ${tariff.pricePerKwh}₽/кВт⋅ч`;
};
export const drawTechnicianLabel = (technician) => {
    return `${technician.firstName} ${technician.lastName} ${technician.phone ? `- ${technician.phone}` : ""}`;
};
